<template>
  <div>
    <div>
      <div>
        <woot-button
          color-scheme="success"
          class-names="button--fixed-right-top"
          icon="add-circle"
          @click="openCreateModal"
        >
          {{ $t('CAMPAIGN.EVALUATIONS.ADD_BTN') }}
        </woot-button>
      </div>

      <!-- tabs  -->

      <section class="campaing_filters">
        <div class="campaing_filter">
          <SearchInput
            v-model="searchValue"
            :placeholder="$t('CAMPAIGN.EVALUATIONS.FILTERS.SEARCH_PLACEHOLDER')"
            @search="onSearch"
          />
        </div>
        <div class="campaing_filter filters__button-wrap">
          <div
            v-if="appliedFilters.length"
            class="filters__applied-indicator"
          />
          <woot-button
            class="margin-right-small clear"
            color-scheme="secondary"
            data-testid="create-new-contact"
            icon="filter"
            @click="onToggleFilter"
          >
            {{ $t('CONTACTS_PAGE.FILTER_CONTACTS') }}
          </woot-button>
        </div>
      </section>
      <div class="mt_20">
        <EvaluationTable
          :cols="cols"
          :is-loading="false"
          :records="records"
          :sort-config="sortConfig"
          @on-edit-click="openEditPopup"
          @on-delete-click="openDeletePopup"
          @on-sort-change="onSortChange"
        />
      </div>
      <div class="loadMore_btn">
        <woot-button
          variant="clear"
          size="small"
          color-scheme="primary"
          :is-loading="uiFlags.isFetching"
          :is-disabled="paginationCompute.isLastPage"
          @click="onPageChange(Number(meta.current_page) + 1)"
        >
          {{ paginationCompute.btnText }}
        </woot-button>
      </div>

      <CreateEvaluation
        v-if="isCreateModalOpen"
        :show="isCreateModalOpen"
        :edit-evaluation="editRow"
        @success="onCloseCreateModal"
        @cancel="onCloseCreateModal"
      />
      <DeleteModal
        :show="!!deleteRow"
        :title="$t('COUPON.DELETE_MODAL.TITLE')"
        :on-confirm="onConfirmDelete"
        :on-close="onCloseDeleteModal"
        :confirm-text="$t('COUPON.DELETE_MODAL.CONFIRM_BTN')"
        :reject-text="$t('COUPON.DELETE_MODAL.REJECT_BTN')"
      />
      <woot-modal
        :show.sync="showFiltersModal"
        :on-close="onToggleFilter"
        size="medium"
      >
        <EvalAdvancedFilter
          v-if="showFiltersModal"
          :on-close="onToggleFilter"
          :filter-items="filterItems"
          :initial-applied-filters="appliedFilters"
          :filter-attributes="filterAttributes"
          @applyFilter="onApplyFilter"
          @clearFilters="clearFilters"
        />
      </woot-modal>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import alertMixin from 'shared/mixins/alertMixin';
import helperMixin from 'shared/mixins/helperMixin';
import CreateEvaluation from './CreateEvaluation.vue';
import EvaluationTable from './EvaluationTable.vue';
import DeleteModal from 'components/widgets/modal/DeleteModal.vue';
import SearchInput from 'dashboard/components/ui/SearchInput.vue';
import { evalFilterTypes, FilterAttributList } from './evaluationConstant';
import EvalAdvancedFilter from './EvalAdvancedFilter.vue';

export default {
  components: {
    EvaluationTable,
    CreateEvaluation,
    DeleteModal,
    SearchInput,
    EvalAdvancedFilter,
  },
  mixins: [helperMixin, alertMixin],
  data() {
    return {
      searchValue: '',
      sortConfig: { name: 'asc' },
      isCreateModalOpen: false,
      showFiltersModal: false,
      filterItems: evalFilterTypes.map(filter => ({
        ...filter,
        attributeName: this.$t(`${filter.attributeI18nKey}`),
      })),
      appliedFilters: [],
      cols: [
        { key: 'name', name: 'Name', visible: true, type: 'default' },
        { key: 'prompt', name: 'Prompt', visible: true, type: 'default' },
        { key: 'kind', name: 'Kind', visible: true, type: 'default' },
        { key: 'active', name: 'Status', visible: true, type: 'default' },
        {
          key: 'agent_name',
          name: 'Agent Name',
          visible: true,
          type: 'default',
        },
        {
          key: 'triger',
          name: 'When to triger',
          visible: true,
          type: 'default',
        },
        { key: 'action', name: 'action', visible: true, type: 'default' },
      ],
      editRow: null,
      deleteRow: null,
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'evaluations/getUIFlags',
      meta: 'evaluations/getMeta',
      records: 'evaluations/getEvaluations',
    }),
    paginationCompute() {
      const totalPages = Math.ceil(this.meta.count / this.meta.page_size);
      const isLastPage = this.meta.current_page >= totalPages;
      const currentCount = Math.min(
        this.meta.current_page * this.meta.page_size,
        this.meta.count
      );
      const btnText = `${this.$t(
        'CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.AGENT_CALL_REPORT.LOAD_MORE_BTN'
      )} (${currentCount}/${this.meta.count})`;

      return {
        isLastPage,
        btnText,
      };
    },
    filterAttributes() {
      return FilterAttributList.map(el => ({ ...el, name: this.$t(el.name) }));
    },
  },
  mounted() {
    // When revisiting the route (with <keep-alive>)
    this.$store.dispatch('llmbots/fetchLLMBots');
    this.getEvaluationList({
      page: 1,
    });
  },
  methods: {
    getEvaluationList(query = {}) {
      try {
        const defautQuery = {
          page: this.meta.current_page,
          page_size: this.meta.page_size,
          q: this.searchValue,
          payload: this.appliedFilters,
          sort: this.getSortAttribute(this.sortConfig),
          ...query,
        };

        defautQuery.payload = defautQuery.payload.map(el => {
          const temp = { ...el };
          if (el.attribute_key === 'kind') {
            temp.values = [el.values.id];
            return temp;
          }
          temp.values = [el.values];
          return temp;
        });

        if (defautQuery.payload?.length) {
          this.$store.dispatch(
            'evaluations/filterEvaluations',
            this.cleanObject(defautQuery)
          );
        } else {
          delete defautQuery.payload;
          this.$store.dispatch(
            'evaluations/fetchEvaluations',
            this.cleanObject(defautQuery)
          );
        }
      } catch (error) {
        console.error('Error fetching evaluation list:', error);
      }
    },
    resetFilterFileds() {
      this.searchValue = '';
    },
    onPageChange(page) {
      this.getEvaluationList({ page });
    },
    onSearch(value) {
      this.getEvaluationList({ q: value, page: 1 });
    },
    getSortAttribute(newSort = {}) {
      let sortAttr = Object.keys({ ...this.sortConfig, ...newSort }).reduce(
        (acc, sortKey) => {
          const sortOrder = this.sortConfig[sortKey];
          if (sortOrder) {
            const sortOrderSign = sortOrder === 'asc' ? '' : '-';
            return `${sortOrderSign}${sortKey}`;
          }
          return acc;
        },
        ''
      );
      if (!sortAttr) {
        this.sortConfig = { name: 'asc' };
        sortAttr = 'name';
      }
      return sortAttr;
    },
    onSortChange(params) {
      let sortDetails = {};
      Object.keys(params).forEach(key => {
        if (params[key] !== '') {
          if (!['name', 'agent_name'].includes(key)) {
            sortDetails = {};
            sortDetails.key = key;
            sortDetails.order = params[key];
          }
        }
      });
      this.sortConfig = params;
      const sort = this.getSortAttribute(sortDetails);
      this.getEvaluationList({ sort, page: 1 });
    },
    openCreateModal() {
      this.isCreateModalOpen = true;
    },
    onCloseCreateModal() {
      this.editRow = null;
      this.isCreateModalOpen = false;
    },
    openEditPopup(row) {
      this.editRow = row;
      this.openCreateModal();
    },
    async openDeletePopup(row) {
      this.deleteRow = row;
    },
    onCloseDeleteModal() {
      this.deleteRow = null;
    },
    async onConfirmDelete() {
      try {
        await this.$store.dispatch('evaluations/deleteEvaluationById', {
          evaluation_id: this.deleteRow?.id,
        });
        this.onCloseDeleteModal();
        this.showAlert(
          this.$t('CAMPAIGN.EVALUATIONS.ADD.BTNS.SUCCESS_MSG_DELETE')
        );
      } catch (error) {
        console.error('Error deleting evaluation:', error);
        this.showErrAlert(error, 'Something went wrong!');
      }
    },
    onToggleFilter() {
      this.showFiltersModal = !this.showFiltersModal;
    },
    onApplyFilter(filters) {
      this.appliedFilters = filters;
      this.getEvaluationList({ payload: filters, page: 1 });
      this.onToggleFilter();
    },
    clearFilters() {
      this.appliedFilters = [];
      this.getEvaluationList({ payload: [], page: 1 });
    },
  },
};
</script>

<style scoped lang="scss">
.search_container {
  //   margin-top: 16px;
  max-width: 280px;
}

.campaing_filters {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 16px;
  .campaing_filter {
    p {
      margin-bottom: 8px;
    }
  }
}
.loadMore_btn button {
  display: block;
  margin: auto;
}

.filters__button-wrap {
  position: relative;

  .filters__applied-indicator {
    position: absolute;
    height: var(--space-small);
    width: var(--space-small);
    top: var(--space-smaller);
    right: var(--space-slab);
    background-color: var(--s-500);
    border-radius: var(--border-radius-rounded);
  }
}
</style>
